import { render } from "./ios-refresh.vue?vue&type=template&id=8f3f8a3c"
import script from "./ios-refresh.vue?vue&type=script&lang=js"
export * from "./ios-refresh.vue?vue&type=script&lang=js"
script.render = render

export default script